import ProjectCollectionLocalSettings from "../project-collection-local-settings"
import ProjectCollectionModel from "../../../model2/project-collection/project-collection-model"
import {ViewType} from "../../../gd/const/views/view-type"
import projectCollectionView_isPro from "./functions/project-collection-view-is-pro";
import {ViewTypeConfigs} from "../../../gd/const/views/view-type-config";
import {OpenProjectCollectionViewOptions} from "../@types"

const debug = false
// const debug = "ProjectCollectionView"

export default class ProjectCollectionView {

    public projectCollection    : ProjectCollectionModel
    public projectCollectionId  : ID
    public config               : any

    public id                   : ID
    public systemType           : ViewType
    public name                 : string
    public sortPosition         : number
    public sharedViewId         : ID | null
    public appSettings          : any
    public isMandatory          : boolean

    public url                  : string
    public isPro                : boolean | undefined
    public icon                 : string

    public hasMoreMenu          : boolean

    public availableActions!    : {
        canRename           : boolean
        canDuplicate        : boolean
        canResetToDefault   : boolean
        canDelete           : boolean
    }

    constructor(viewConfig: any, projectCollection: ProjectCollectionModel) {

        this.projectCollection      = projectCollection // session.projectCollection
        this.projectCollectionId    = projectCollection.id
        this.config                 = viewConfig

        debug && console.log(debug,"constructor", this.projectCollectionId, viewConfig)

        this.id             = this.config.id
        this.systemType     = _.get(this.config, 'systemType', ViewType.PORTFOLIO_LIST) // just in case task list no nam nado vsegda imet'
        this.name           = _.get(this.config, 'name', this._getViewNameBySystemType())
        this.sortPosition   = _.get(this.config, 'sortPosition', 0)
        this.sharedViewId   = _.get(this.config, 'sharedViewId', null)
        this.appSettings    = _.get(this.config, 'appSettings', null)
        this.isMandatory    = _.get(this.config, 'isMandatory', false) // is mandatory then it can't be deleted

        if (!_.isEmpty(this.config.appSettings)) this.resetLocalAppSettings() // just in case

        const viewTypeConfig = ViewTypeConfigs[this.systemType]

        this.url            = projectCollection.url + '/' + viewTypeConfig?.url + '/' + this.id

        this.isPro          = projectCollectionView_isPro(this.systemType); //render pro submenu item
        this.icon           = viewTypeConfig?.icon!

        this.hasMoreMenu    = this.systemType !== ViewType.PORTFOLIO_INFO // if false no more menu is available

        this.updateAvailableActions()

        debug && console.log(debug,"constructor done", this)
    }

    updateAvailableActions() {
        const isFullAccessUser = this.projectCollection.isFullAccessUser

        this.availableActions = {
            canRename:              isFullAccessUser,
            canDuplicate:           isFullAccessUser,
            canResetToDefault:      isFullAccessUser && !!this.appSettings,
            canDelete:              isFullAccessUser && !this.isMandatory,
        }
    }

    // to customize open behaviour (for example for ProjectView_Link)
    open(options?: OpenProjectCollectionViewOptions) {
        gd.navigation.goTo(this.url, false)
    }

    copyUrl() {
        const url = window.location.origin + '/' + this.url
        gd.utils.copyToClipboard(url);
        gd.growl.success('URL copied to clipboard.')
    }

    _getViewNameBySystemType() {
        return ViewTypeConfigs[this.systemType as ViewType]!.menuName
    }

    // App Settings
    applyAppSettings(appSettingsConfig: any) {
        this.saveAppSettings(appSettingsConfig)
        this.resetLocalAppSettings()
    }

    resetLocalAppSettings() {
        //reset view appSettings in projectLocalSettings if found
        const projectLocalSettings = new ProjectCollectionLocalSettings(this.projectCollectionId)
        projectLocalSettings.resetViewAppSettings(this.id)
    }

    saveAppSettings(newAppSettingsConfig: any) {
        debug && console.log(debug,"saveAppSettings start=");

        const view = _.find(this.projectCollection.views, v=>v.id === this.id)
        view.appSettings = _.isEmpty(newAppSettingsConfig) ? null : newAppSettingsConfig
        this.appSettings = view.appSettings

        // projectCollection should be in updatedFields for save to work
        this.projectCollection.save()

        debug && console.log(debug, "saveAppSettings done")
    }

    // conversion
    toJson() {
        const config: any = {
            id          : this.id,
            systemType  : this.systemType,
            name        : this.name,
            sortPosition: this.sortPosition,
            appSettings : this.appSettings
        }

        if (this.sharedViewId)  config.sharedViewId = this.sharedViewId
        if (this.isMandatory)   config.isMandatory = this.isMandatory

        return config
    }
}
